export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-[72px] overflow-hidden bg-background-50"
    >
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-16">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-6">
              <i className="ri-fire-line text-sm"></i>
              <span>日漫 · 韩漫 · 全集免费</span>
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-4">
              亲亲漫画网
              <span className="block text-primary-500 text-2xl md:text-3xl lg:text-4xl mt-2">免费下拉式漫画阅读平台</span>
            </h1>

            <p className="text-lg text-primary-600 font-heading italic mb-6">
              滑动阅读，沉浸追更，好漫画一气呵成
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[560px] mx-auto lg:mx-0 mb-8">
              亲亲漫画网汇集海量日漫、韩漫资源，采用流畅的下拉式阅读体验，告别翻页打断节奏。每日追踪更新热门连载，涵盖热血、恋爱、奇幻、搞笑等全品类题材。无论是经典全集重温，还是最新连载追更，只需轻轻滑动，精彩故事即刻呈现。本站保持日更50+部漫画的更新频率，所有内容免费在线阅读，无广告干扰，只为给你最纯粹的下拉式漫画阅读之旅。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">50+</div>
                <div className="text-xs text-foreground-500 mt-1">部/日更新</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-500 font-heading">30000+</div>
                <div className="text-xs text-foreground-500 mt-1">部漫画资源</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-secondary-500 font-heading">全免费</div>
                <div className="text-xs text-foreground-500 mt-1">随时畅读</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#cards"
                onClick={(e) => { e.preventDefault(); document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap no-underline cursor-pointer text-sm"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始阅读
              </a>
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-2 px-8 py-3 bg-background-100 text-foreground-800 font-medium rounded-full hover:bg-background-200 transition-colors duration-200 whitespace-nowrap no-underline cursor-pointer text-sm border border-background-300"
              >
                <i className="ri-trophy-line text-lg"></i>
                热门排行
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] md:max-w-[520px] aspect-[4/5] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20beautiful%20Japanese%20manga%20style%20illustration%20featuring%20a%20dynamic%20anime%20character%20with%20flowing%20hair%20reading%20a%20manga%20book%2C%20surrounded%20by%20floating%20manga%20pages%20and%20speech%20bubbles%2C%20warm%20vibrant%20colors%20with%20orange%20and%20coral%20tones%2C%20soft%20gradient%20background%20with%20subtle%20comic%20panel%20lines%2C%20artistic%20and%20dreamy%20atmosphere%2C%20highly%20detailed%20illustration%2C%20modern%20anime%20art%20style%2C%20clean%20composition%2C%20professional%20quality&width=1040&height=1300&seq=hero-manga-main&orientation=portrait"
                alt="亲亲漫画网 - 下拉式漫画阅读体验"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/20 to-transparent pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}